export default {
    namespaced: true,
    state: {
        device: 'desktop',
        screenSize: 'normal'
    },
    mutations: {
        TOGGLE_DEVICE: (state, device) => {
            state.device = device
        },
        TOGGLE_SCREEN_SIZE: (state, size) => {
            state.screenSize = size || 'normal'
        },
    },
    actions: {
        toggleDevice({commit}, device) {
            commit('TOGGLE_DEVICE', device)
        },
        toggleScreenSize({commit}, size) {
            commit('TOGGLE_SCREEN_SIZE', size)
        },
    }
}
